import { useEffect, useState } from 'react'

/* 
Este custom hook permite dar una espera cada que se escribe en el input para realizar la consulta
Asi no se realizará una consulsta a la base de datos cada vez que se escribe un caracter en el input
Sino que se realizará x segundos después de que el usuario deje de escribir
*/

export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value)

    useEffect(() => {
        if (!value) return setDebouncedValue(value)

        const handler = setTimeout(() => {
            setDebouncedValue(value)
        }, delay)

        return () => {
            clearTimeout(handler)
        }
    }, [value, delay])

    return debouncedValue
}